<template>
    <page>
        <module :title="id ? '编辑拼团活动' : '新建拼团活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="activity_id" v-model="activity_id" required></c-form-item>
                    <c-form-item type="hidden" name="group_product_type" v-model="group_product_type" required></c-form-item>
                    <c-form-item type="input" label="活动名称"  name="activity_name"  maxlength="20" required></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="number" decimal="1" label="拼团有效期" :limit="[0.1,9999]" name="valid_time" required input-unit="时"
                                 word="拼团发起后，必须在该时间内成团，否则拼团将自动失败；相关订单关闭，支付金额原路退还"></c-form-item>
<!--                    <c-form-item type="radio" label="参团方式" name="group_product_type" v-model="group_product_type" :options="groupProductTypeOptions" required
                                 word="【SKU】：参团人只能购买与开团人相同的SKU；【商品】：参团人可以购买与开团人不同的SKU" ></c-form-item>-->
                    <c-form-item type="input" label="活动标签" name="tags"  maxlength="4"></c-form-item>
                    <c-form-item type="radio" label="活动预告设置" value="-1"  name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" required word="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" ></c-form-item>
                    <c-form-item type="number" v-if="activityNotice == 1" decimal="1" :limit="[0.1,9999]" v-model="activityNoticeTime"  name="activity_notice_time" word="小时"></c-form-item>
                </c-form>

                <c-form title="活动商品">
                    <c-form-item>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                            <c-button color="gray" hollow @click="setGroupType">批量设置成团方式</c-button>
                            <c-button color="gray" hollow @click="setGroupCount">批量设置成团数量</c-button>
                            <c-button color="gray" hollow @click="setGroupUnitPrice">批量设置拼团单价</c-button>
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column
                                    type="selector"
                            ></c-table-column>

                          <c-table-column
                              label="商品信息"
                              name="product_name"
                              width="250"
                          >
                            <template v-slot="{data}">
                              <div class="flex-center">
                                <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                    <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                    {{data.product_name}}
                                </p>
                              </div>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="商品状态"
                              name="state"
                              width="80"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_product_id==null" style="color:gray">待保存</span>
                              <span v-if="data.activity_product_id && data.state == 0" style="color:red">结束</span>
                              <span v-if="data.activity_product_id && data.state == 1" style="color:green">正常</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                                label="价格"
                                name="product_price"
                                width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                label="成团方式"
                                width="80"
                            >
                                <template v-slot="{data}">
                                    <c-select v-model="data.group_type"  width="60" :options="groupTypeOptions"></c-select>
                                </template>
                            </c-table-column>

                            <c-table-column
                                label="成团数量"
                                width="80"
                            >
                                <template v-slot="{data}">
                                    <c-input  v-model="data.min_group_count" width="60" type="number" :limit="[2, 99]"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                label="拼团单价"
                                width="80"
                            >
                                <template v-slot="{data}">
                                    <c-input type="number" decimal="2" v-model="data.group_unit_price" :limit="[0.01, data.group_unit_price]" width="60"  style="margin: 0 5px;"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="80"
                            >
                                <template v-slot="row">
<!--
                                    <c-table-button v-if="id == null || row.data.activity_product_id==null||row.data.state==0" @click="row.remove()">删除</c-table-button>
-->
                                    <c-table-button v-if="id && row.data.activity_product_id && row.data.state==1" @click="over(row,0)">结束</c-table-button>
                                    <c-table-button v-if="id && row.data.activity_product_id && row.data.state==0" @click="over(row,1)">开始</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button v-show="editFlag" power="b_activity_group_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <c-dialog ref="groupCountDialog" title="批量设置成团数量" width="400" height="150" @resolve="setGroupCountHandle">
            <c-form>
                <c-form-item  label="成团数量" required>
                    <c-input  v-model="min_group_count" decimal="0"  width="200" type="number" :limit="[1, 9999]" style="margin: 0 5px;"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="groupUnitPriceDialog" title="批量拼团单价" width="400" height="150" @resolve="setGroupUnitPriceHandle">
            <c-form>
                <c-form-item  label="拼团单价" required>
                    <c-input  v-model="group_unit_price" width="200" type="number" decimal="2"  :limit="[0.01, 9999]" style="margin: 0 5px;"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="groupTypeDialog" title="批量设置成团方式" width="400" height="180" @resolve="setGroupTypeHandle">
            <c-form>
                <c-form-item label="成团方式"  v-model="group_type"  type="select" :options="groupTypeOptions"></c-form-item>
            </c-form>
        </c-dialog>

      <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    export default {
        name: 'activity_group_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                activityNoticeTime: 0,
                activityNotice: -1,
                group_type: 1,
                groupTypeOptions: [
                    {name: '参团人数',value: 1},
                ],
                activityNoticeOptions: [
                    {name: '立即预告',value: 0},
                    {name: '不预告',value: -1},
                    {name: '提前预告',value: 1}
                ],
                group_product_type:1,
                groupProductTypeOptions: [
                    {name: 'SKU',value: 1},
                    {name: '商品',value: 2}
                ],
                isRandomReduceOptions: [{
                    name: '随机',
                    value: 1
                }],
                activity_id: '',
                min_group_count: 0,
                group_unit_price: '',
                min_price_order: '',
                productList: [],
                editFlag: true,
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },

            commodityRange(val) {
                if (val == 2) {
                    this.$refs.productList.resize();
                }
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activity/group/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if(data.start_state == "1"){
                            this.editFlag = false;
                        }
                        this.activityNoticeTime = data.activity_notice_time;
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                list.forEach(item=>{
                    item.state = 1;
                    item.min_price_order = 1;
                })
                //检查商品时间是否和其他活动重叠
                this.productList = this.productList.concat(list);
            },
            over(row,state){
                row.data.state = state;
            },
            /**
             * 设置成团数量
             * */
            setGroupCount() {
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.min_group_count = 0;
                this.$refs.groupCountDialog.open();

            },
            
            setGroupCountHandle(stop) {
                if (!this.min_group_count) {
                    stop();
                    this.$message({
                        text: '请填写最低价'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        min_group_count: this.min_group_count
                    });
                });
            },

            setGroupUnitPrice(){
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.group_unit_price = '';
                this.$refs.groupUnitPriceDialog.open();
            },

            /**
             * 批量设置【拼团单价】-响应函数
             * @param stop
             */
            setGroupUnitPriceHandle(stop) {
                if (!this.group_unit_price) {
                    stop();
                    this.$message({
                        text: '请设置拼团单价'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        group_unit_price: this.group_unit_price
                    });
                });
            },
            /**
             * 批量设置【拼团单价】-响应函数
             * @param stop
             */
            setGroupType(){
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.min_price_order = '';
                this.$refs.groupTypeDialog.open();
            },

            setGroupTypeHandle(stop) {
                if (!this.group_type) {
                    stop();
                    this.$message({
                        text: '请选择成团方式'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        group_type: this.group_type
                    });
                });
            },

            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activity/group/edit' : '/activity/group/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        end_date: '请选择活动时间',
                        valid_time: '请填写拼团有效期',
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                return this.productList.length;
                            },
                            word: '请选择活动商品'
                        }],
                        product_config1: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    if(item.group_type == 0){
                                        return false
                                    }
                                    return !item.group_type;
                                });
                            },
                            word: '请设置商品成员方式'
                        }],
                        product_config2: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.min_group_count;
                                });
                            },
                            word: '请设置成团数量'
                        }],
                        product_config3: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    return !item.group_unit_price;
                                });
                            },
                            word: '请设置拼团单价'
                        }]
                    },
                    dataFormatter: data => {
                        this.id && (data.id = this.id);

                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                group_type: Number.parseInt(item.group_type||1),
                                min_group_count: Number.parseFloat(item.min_group_count),
                                group_unit_price: Number.parseFloat(item.group_unit_price),
                                state: item.state
                            }
                        });
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
                                text: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
                                text: "保存成功",
                            });
                        }

                        this.$bus.$emit('activityGroupList.update');
                        this.redirectTo('/activity_group');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>